"use strict";
/**
 * 期货简单表格
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowCrumbsWithRefreshLine = exports.PageQiHuoGrid = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var react_router_dom_1 = require("react-router-dom");
require("./page.less");
var qihuotable_1 = require("../qihuotable");
var delaytips_1 = require("./shared/delaytips");
var user_1 = __importDefault(require("../../modules/user"));
var thisuser = user_1.default.get();
/**
 * 需要展示延时tip
 */
var showdelayhash = [
    'futures_cffex',
];
/**
 * 简单期货表格页面
 * @returns
 */
function PageQiHuoGrid() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash_no_sharp = location.hash;
    if (hash_no_sharp.substring(0, 1) == '#') {
        hash_no_sharp = hash_no_sharp.substring(1);
    }
    // let [mounted, setMounted] = useState(false)
    // let [delaymessage, setDelayMess] = useState({re: false,message: ""})
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
    }, [hash_no_sharp]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ShowCrumbsWithRefreshLine, null),
        react_1.default.createElement(qihuotable_1.QiHuoTable, null),
        hash_no_sharp == "futures_finance" &&
            react_1.default.createElement("a", { "tracker-eventcode": "hqzx_jrqh_ckgdjrqh_dj", style: { display: "block", marginTop: "10px" }, href: "https://zqhd.eastmoney.com/Html/aghd/pc/20170918/html/activity2.html?tz=xxlout_dfcfappweb_random_0001447a", dangerouslySetInnerHTML: { __html: "剩余28个国际金融期货，请至东方财富APP内查看>>" } })));
}
exports.PageQiHuoGrid = PageQiHuoGrid;
function ShowCrumbsWithRefreshLine() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash_sharp = location.hash;
    //中金所合规tips
    if (hash_sharp.indexOf('#futures_cffex') == 0 || hash_sharp.indexOf('#futures_220') == 0) {
        return react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, { insertRight: (0, delaytips_1.DelayMin15Tip)(), hideFresh: true });
    }
    //CME合规tips
    if (thisuser == null && (hash_sharp.indexOf('#futures_global-nymex') == 0 || hash_sharp.indexOf('#futures_global-cobot') == 0 || hash_sharp.indexOf('#futures_global-comex') == 0 || hash_sharp.indexOf('#nobalmetal_futures') == 0)) {
        return react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, { insertRight: (0, delaytips_1.CMETip)(), hideFresh: true });
    }
    return react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null);
}
exports.ShowCrumbsWithRefreshLine = ShowCrumbsWithRefreshLine;
